<!--
 * @Author: your name
 * @Date: 2020-04-14 08:39:13
 * @LastEditTime: 2020-04-14 08:53:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\news11.vue
 -->
<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        大连海大智龙航海教学在线实操训练学习平台，在家免费上课
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-04-10</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5">

      </div>
      <div class="div-row div-bottom30">
        <p class="indentation">
          席卷全球的新冠疫情，对航海教育的冲击也日渐显现出来。虽然各个航海院校和船员培训机构的航海类教师已通过各种远程教学软件开展课程教学，但是对于需要学习实践性很强的航海类实操课程的学员来说，还迫切需要能够进行网上实操训练的模拟软件，如：
        </p>
        <ul style="text-align:left;">
          <li> ECDIS模拟实训软件</li>
          <li> 雷达/ARPA模拟实训软件</li>
          <li> GMDSS模拟实训软件</li>
          <li> 装载计算机软件等</li>
        </ul>
        <p class="indentation">
          大连海大智龙科技有限公司是大连海事大学航海模拟器研发团队通过科技成果转化、注册成立的股份制高科技企业。公司为助力各航海院校、培训机构及航运公司共克时艰，搭建了远程航海教育在线实操平台，快速整合了公司现有成熟实操类产品，以解决目前实训教学无法开展的难题。
        </p>
        <img src="static/imgts/news11/1.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isflag1: true,
        isflag2: false,
        isflag3: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }
        if (parseInt(scrollTop) >= 1200) {
          this.isflag3 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
  img {
    margin-top: 30px;
  }

  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  .div-padding-left {
    padding-left: 36px;
  }

  .div-top30 {
    margin-top: 30px;
  }

  .div-top0 {
    margin-bottom: 0px !important;
  }

  img {
    vertical-align: middle;
    border-style: none;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news11.vue